import { z } from 'zod'
import { stripTaxesText } from '@/helpers'

export const fiscalNoteFormSchema = z.object({
  borrower: z
    .object({
      key: z.string(),
      name: z.string(),
      tax_id: z.string(),
      tax_id_type: z.enum(['cpf', 'cnpj']),
      email: z.string().optional(),
      phone: z.string().optional(),
    })
    .refine((data) => data.key && data.name && data.tax_id, 'Obrigatório'),
  value: z.string().min(1, 'Obrigatório'),
  service_code_id: z.string().min(1, 'Obrigatório'),
  service_tax_rate: z.string().min(1, 'Obrigatório'),
  service_tax_code: z.string().optional(),
  cnae_id: z.string().min(1, 'Obrigatório'),
  description: z
    .string()
    .refine((value) => stripTaxesText(value).trim().length > 0, 'Obrigatório'),
  iss_retention: z.boolean(),
  state_uf: z.string().nullish(),
  municipality_ibge_code: z.string().nullish(),
  csll: z.string().optional(),
  irrf: z.string().optional(),
  pis: z.string().optional(),
  cofins: z.string().optional(),
})

export type FiscalNoteFormData = z.infer<typeof fiscalNoteFormSchema>
